__turbopack_context__.v({
  "className": "bricolage_grotesque_608f66a5-module__C5xDtq__className",
});
